import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import PostForm from '@app/components/apps/Post/PostForm';

export const ViewPost: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Post');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/posts',
      breadcrumbName: 'Posts',
    },
    {
      path: '/view-post',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <PostForm
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Post`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Row>
    </>
  );
};

export default ViewPost;
